<div class="body">

    <div class="main-resultados">

        <mat-toolbar class="mat-elevation-z2 noselect toolbar-titulo">
            <div class="loading-shade" id="carregamento" style="visibility: hidden;">
                <mat-spinner></mat-spinner>
            </div>

            <div class="div-botao-voltar" (click)="voltar()">
                <mat-icon style="color: #ff0000"> navigate_before </mat-icon>
                <button mat-button class="botao-voltar">
                    <p class="p-botao-voltar">
                        Voltar
                    </p>
                </button>
            </div>

            <span class="barra-topo"></span>

            <div class="div-resultados">
                <p class="p-resultados">
                    Resultados
                </p>
            </div>

        </mat-toolbar>

        <div class="div-body">

            <title-line title="Resultados"></title-line>

            <mat-card class="mat-card-resultados">

                <div class="table">

                    <table mat-table [dataSource]="historicoSource">
                        <!-- [dataSource]="historicoSource" -->
                        <ng-container matColumnDef="nomedoCliente">
                            <th mat-header-cell *matHeaderCellDef class="md"> Nome Cliente </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element?.nomedoCliente ? element.nomedoCliente : ' - '}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="md"> Status do Cliente </th>
                            <td mat-cell *matCellDef="let element" (click)="goToEditarResultados(element.id)"
                                style="cursor: pointer;" [ngClass]="element?.status === 5 ? 'green' : 'red'">
                                <strong>{{ element?.status === 5 ? 'Matriculado' : 'Não Matriculado'}}</strong>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="celular">
                            <th mat-header-cell *matHeaderCellDef class="md"> Telefone </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element?.celular ? (element.celular | mask: ajustarMaskTelefone(element.celular))
                                :
                                '-'}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="historicoColumns"></tr>

                        <tr mat-row *matRowDef="let row; columns: historicoColumns;"></tr>

                    </table>

                </div>
            </mat-card>

        </div>

        <div class="div-rodape">

            <div class="div-barra-navegacao">

                <button class="b-home">
                    <mat-icon class="mat-icon-button" (click)="goToHome()"> home </mat-icon>
                </button>

                <button class="b-novo-atendimento">
                    <mat-icon class="mat-icon-button" (click)="goToNovoAtendimento()"> add </mat-icon>
                </button>

                <button class="b-pesquisar">
                    <mat-icon class="mat-icon-button" (click)="goToPesquisar()"> search </mat-icon>
                </button>

                <button class="b-agendados">
                    <mat-icon class="mat-icon-button" (click)="goToAgendados()"> calendar_today </mat-icon>
                </button>
            </div>

        </div>

    </div>

</div>